import { UserSwitchOutlined } from "@ant-design/icons";
import { FC, useCallback } from "react";
import { AnyTask, Market } from "tm-shared/types";

import BaseButton from "@/components/BaseButton";
import { isManagerRole } from "@/hooks/isManagerRole";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { addModalToQueue } from "@/store/slices/ui";
import { ModalType } from "@/types/modals";

interface ICustomTaskFromTaskButton {
    market: Market;
    task: AnyTask;
    images: string[];
}

export const CustomTaskFromTaskButton: FC<ICustomTaskFromTaskButton> = ({
    market,
    images,
    task,
}) => {
    const dispatch = useAppDispatch();
    const { role } = useAppSelector((s) => s.user);
    const createCustomTaskForAgent = useCallback(async () => {
        if (images.length) {
            dispatch(
                addModalToQueue({
                    type: ModalType.CustomTaskAddPhotos,
                    id: ModalType.CustomTaskAddPhotos,
                    payload: {
                        market,
                        images,
                        task,
                    },
                }),
            );
        } else {
            dispatch(
                addModalToQueue({
                    type: ModalType.CreateCustomTask,
                    id: ModalType.CreateCustomTask,
                    payload: {
                        market,
                        images,
                    },
                }),
            );
        }
    }, [dispatch, market]);

    if (!isManagerRole(role)) return null;
    return (
        <BaseButton
            icon={<UserSwitchOutlined />}
            onClick={createCustomTaskForAgent}
        >
            Створити доручення
        </BaseButton>
    );
};
